import React, { ReactNode } from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

interface StatsCardProps {
  title: string;
  value: number;
  icon: ReactNode;
  change?: number;
  changeLabel?: string;
  positive?: boolean;
  percentage?: number;
  bgColor?: string;
}

const StatsCard: React.FC<StatsCardProps> = ({
  title,
  value,
  icon,
  change,
  changeLabel = 'change',
  positive = true,
  percentage,
  bgColor = 'bg-blue-50'
}) => {
  return (
    <div className={`rounded-lg shadow overflow-hidden`}>
      <div className="px-6 py-5 bg-white">
        <div className="flex items-center">
          <div className={`${bgColor} p-3 rounded-lg`}>
            {icon}
          </div>
          <div className="ml-4">
            <h3 className="text-sm font-medium text-gray-500">{title}</h3>
            <div className="flex items-baseline">
              <p className="text-2xl font-semibold text-gray-900">
                {value.toLocaleString()}
              </p>
              {percentage !== undefined && (
                <p className="ml-2 text-sm text-gray-500">
                  ({percentage}%)
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
      
      {change !== undefined && (
        <div className="px-6 py-2 bg-gray-50">
          <div className="flex items-center">
            {positive ? (
              <TrendingUp className="h-4 w-4 text-green-500" />
            ) : (
              <TrendingDown className="h-4 w-4 text-red-500" />
            )}
            <span className={`ml-2 text-xs font-medium ${positive ? 'text-green-600' : 'text-red-600'}`}>
              {change > 0 ? '+' : ''}{change.toLocaleString()} {changeLabel}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default StatsCard;